<template>
    <TotemTag
        :name="name"
        @handleClick="$emit('handleClick')"
        v-if="selectedLevel"
    />
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        computed: {
            ...mapGetters({
                selectedLevel: 'CourseFilter/getSelectedLevel'
            }),
            name () {
                return this.$t(`Select.skill_level_${this.selectedLevel}`)
            }
        }
    }
</script>
